import './App.css';
import MainAapp from './MainAapp';



function App() {
  return (
    <div>
    <MainAapp />
    </div>
  );
}

export default App;
